import { extendTheme } from "@chakra-ui/react";
import { theme as chakraTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    blue: {
      50: "#E8EEFD",
      100: "#BED0F9",
      200: "#94B2F5",
      300: "#6A94F1",
      400: "#3F76ED",
      500: "#1558EA",
      600: "#1146BB",
      700: "#0D358C",
      800: "#09235D",
      900: "#04122F",
    },
  },
  fonts: {
    ...chakraTheme.fonts,
    heading: `Poppins, sans-serif`,
    body: `Poppins, sans-serif`,
  },
});

export default theme;
